import React from 'react';
import { ForgeCheckbox } from '@tylertech/forge-react';

interface ActionSelectorCheckboxProps {
  isChecked: boolean;
  label: string;
  onClick: () => void;
  dense: boolean;
}

export const ActionSelectorCheckbox = ({ isChecked, label, onClick, dense }: ActionSelectorCheckboxProps) => {
  return (
    <ForgeCheckbox
      dense={dense}
      data-testid="action-selector-checkbox"
      id={label}
      aria-label={label}
      checked={isChecked}
      onClick={onClick}
    >
      {label}
    </ForgeCheckbox>
  );
};
